import { render } from "./table_page_modal2.vue?vue&type=template&id=60035ae8"
import script from "./table_page_modal2.vue?vue&type=script&lang=ts"
export * from "./table_page_modal2.vue?vue&type=script&lang=ts"

import "./table_page_modal2.vue?vue&type=style&index=0&id=60035ae8&lang=css"
script.render = render

export default script